export default __webpack_public_path__ + "static/media/Feature3(2).7ce98928.png";